
import { Router } from '@angular/router';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
declare var $;
import { _ } from 'underscore';
//import { AffilationModel } from 'src/app/shared/models/AffilationModel';
import {AfterViewInit, Component, ViewChild,ElementRef} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import { Clipboard } from '@angular/cdk/clipboard';
import { ExcelService } from '../excel.service';
import * as moment from 'moment-timezone';
export class ZipcodeModel {

  Zip: string;
  Utility: string;
  City: string;
  State: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  id: string;
  _id: string
}

/**
 * @title Data table with sorting, pagination, and filtering.
 */
@Component({
  selector: 'app-admin-zipcode-list',
  templateUrl: './admin-zipcode-list.component.html',
  styleUrls: ['./admin-zipcode-list.component.css'],

})
export class AdminZipcodeListComponent implements AfterViewInit  {
  tUserCount: any;
  enrolledUserCt: any;
  msg;
  title;
  showChangeStatusButtonInPopup = false;
  buttontext = "Ok";
  modalRef: BsModalRef;
  Activate: boolean = false;
  Deactivate: boolean = false;
  Suspend: boolean = false;
  Archive: boolean = false;
  @ViewChild('StatusModel', { static: true }) template: ElementRef;
  residentialHeaderArray;
  displayedColumns: string[] = [
    'select',
        'Action',
        'Zip',
        'Utility',
        'City',
        'State',
        'CreatedBy',
        'CreatedDateTime',
         'ModifiedBy',
         'ModifiedDateTime'
        
      ];
      selected: string;

  dataSource: MatTableDataSource<ZipcodeModel>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  selection = new SelectionModel<ZipcodeModel>(true, []);

    constructor(
    private residentialService: ResidentialService,
    private router: Router,
    private modalService: BsModalService,
    private clipboard: Clipboard,
    private excelService: ExcelService,
  ) {
    // Create 100 users
 
    
    // Assign the data to the data source for the table to render
    this.loadGrid();
  }
  ngAfterViewInit() {

    this.residentialService.checkAdminLOgin();
  }

  openModal(template: ElementRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' })
    );
  }


  Redirect(link)
  {
    this.router.navigate([
      'hg-admin-zipcode-addedit',
      link,
    ]);
  }
  Type;
  ChangeStatus(isWarning = false, Type)
  {
    if(!this.residentialService.checkAdminLOgin())
    {

      this.Type = Type == undefined ?  this.Type :  Type;
      Type = this.Type;
      this.showChangeStatusButtonInPopup = false;
      var selected = this.selection.selected;
      if(selected.length == 0)
      {
        this.title = "";
        this.msg = "Please select atleast one zipcode to " + Type.toLowerCase() + "";
        this.buttontext = "Ok"
        this.openModal(this.template)
        return;
      }
      else if (isWarning)
      {
        this.title = "";
        this.msg = "Are you sure you want to " + Type.toLowerCase() + " of selected zipcode(s)?";
        this.buttontext = "Go Back"
        this.showChangeStatusButtonInPopup = true;
        this.openModal(this.template)
        return;
      }else
      {
        this.modalRef.hide();
      }
   
  
      var UserID;
      if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
        let result = JSON.parse(sessionStorage.getItem('userObj'));
        if (result.userObj._id) {
          UserID = result.userObj._id;
        } 
      }
     
      var query =[];
      selected.forEach(function (value) {
        
       
        if(Type == "Delete")
        {
          query.push({ Type: Type, _id: value._id, Status: "Delete", CreatedBy: UserID, Zip: value.Zip, Utility:value.Utility  })
        }
  
       
  
      }); 
  
      this.residentialService
      .DeleteZipcode(query)
      .subscribe((res: any) => {
  
        this.title = "";
        this.msg = "Zipcode(s) has been deleted successfully";
        this.buttontext = "Ok"
        this.showChangeStatusButtonInPopup = false;
        this.openModal(this.template)
        
        this.router.navigate([
          'hg-admin-zipcode-list',
         
        ]);
  
      });
  
  


    }

  
  }


  StatusChange(completed: boolean, type: string)
  {
    if(type == "Activate")
    {
      this.Activate = completed;
    }
    if(type == "Deactivate")
    {
      this.Deactivate = completed;
    }
    if(type == "Archive")
    {
      this.Archive = completed;
    }
    if(type == "Suspend")
    {
      this.Suspend = completed;
    }
    this.selection.clear();
    this.loadGrid()
  }


  loadGrid()
  {
    this.residentialService
    .GetAllZipcodes()
    .subscribe((res: any) => {


      if( res.length != 0 )
      {
        var applyStatus = false;
        var Activatearr = [];
        var mainArray = [];
        if(this.Activate)
        {
          Activatearr = this.filterItems(res,"Active");
          applyStatus = true;

          if(Activatearr.length != 0 )
          {
            if( mainArray.length != 0)
            {
              mainArray = mainArray.concat(Activatearr)
            }else
            {
              mainArray = Activatearr
            }
          }
          // Activatearr.length != 0 && mainArray.length != 0? 
          // mainArray.concat(Activatearr) : mainArray
        }
        var Deactivatearr = [];
        if(this.Deactivate)
        {
          Deactivatearr = this.filterItems(res,"Deactivated");
          applyStatus = true;
          // Deactivatearr.length != 0 ? 
          // mainArray.concat(Deactivatearr) : mainArray
          if(Deactivatearr.length != 0 )
          {
            if( mainArray.length != 0)
            {
              mainArray = mainArray.concat(Deactivatearr)
            }else
            {
              mainArray = Deactivatearr
            }
          }
        }
        var Suspendarr = [];
        if(this.Suspend)
        {
          Suspendarr = this.filterItems(res,"Suspended");
          applyStatus = true;
          // Suspendarr.length != 0 ? 
          // mainArray.concat(Suspendarr) : mainArray
          if(Suspendarr.length != 0 )
          {
            if( mainArray.length != 0)
            {
              mainArray = mainArray.concat(Suspendarr)
            }else
            {
              mainArray = Suspendarr
            }
          }
        }
        var Archivearr = [];
        if(this.Archive)
        {
          Archivearr = this.filterItems(res,"Archived");
          applyStatus = true;
          // Archivearr.length != 0 ? 
          // mainArray.concat(Archivearr) : mainArray
          if(Archivearr.length != 0 )
          {
            if( mainArray.length != 0)
            {
              mainArray = mainArray.concat(Archivearr)
            }else
            {
              mainArray = Archivearr
            }
          }
        }
      }
      if(applyStatus == true)
      {
        //Activatearr.concat(Deactivatearr,Suspendarr,Archivearr);
        this.dataSource = new MatTableDataSource(mainArray);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
      else
      {
        this.dataSource = new MatTableDataSource(res);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }

      setTimeout(function(){
        $('[data-toggle="tooltip"]').tooltip({
          animated: 'fade',
          placement: 'bottom',
          trigger: 'click'
      });
  

      },1000)
      // this.dataSource = new MatTableDataSource(res);
      // this.dataSource.paginator = this.paginator;
      // this.dataSource.sort = this.sort;

    });
  }
  filterItems(arr, query) {
    //return arr.filter((el) => el.Status.toLowerCase().includes(query.toLowerCase()));
    return arr.filter((el) => el.Status.toLowerCase() == query.toLowerCase());
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  checkboxLabel(row?: ZipcodeModel): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  isAllSelected() {
    var numRows = 0
    const numSelected = this.selection.selected.length;
    if(this.dataSource != undefined)
    {
      numRows = this.dataSource.data.length;
    }
   
    return numSelected === numRows;
  }

  exportAsXLSX() {
   
        this.residentialHeaderArray = this.displayedColumns;
        this.excelService.generateExcel(
          this.setExcelColumnsData(),
          this.residentialHeaderArray,
          null,
          null,
          'Zipcodes',
          this.enrolledUserCt,
          this.tUserCount
        );
      
    
  }

  setExcelColumnsData() {
    let dataArr = [];
    this.dataSource.filteredData.map((row: any) => {
      const columns = {
        'Zipcode': row.Zip,
        'Utility Name': row.Utility,
        'City': row.City,
        'State': row.State,
        'Created By': row.CreatedBy,
        'Created Date': row.CreatedDateTime != "" && row.CreatedDateTime != null ? moment(new Date(row.CreatedDateTime)).format('MM/DD/YYYY h:mm A'): "",
        'Modified By': row.ModifiedBy,
        'Modified Date': row.ModifiedDateTime != "" && row.ModifiedDateTime != null ?  moment(new Date(row.ModifiedDateTime)).format('MM/DD/YYYY h:mm A') : "",
        
        
      };
      dataArr.push(columns);
    });
    return dataArr;
  }


}


function formatAMPM(date: Date) {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  };
  return date.toLocaleString('en-US', options);
}


